// extracted by mini-css-extract-plugin
module.exports = {"img":"DailyCard_img__3Oc0_","logo":"DailyCard_logo____iQ4"};